import { cnpj } from 'cpf-cnpj-validator'
import { validate as cpf } from 'gerador-validador-cpf'

const ValidatorService = { validateCNPJ: cnpj.isValid, validateCPF: cpf }

export default ValidatorService
